import {
  Button,
  Container,
  CssBaseline,
  TextField,
  Typography,
} from "@material-ui/core";
import useStyles from "components/Auth/Register/RegisterStyles";
import React, { useEffect, useState } from "react";
import { checkEmailValid, checkFieldValid } from "components/User/Validation";
import useActions from "../actions";
import { useSelector } from "react-redux";
import { USER_PROP } from "components/User/constants";
import PasswordField from "components/common/PasswordField";

const PasswordChange = () => {
  const classes = useStyles();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [isFormValid, setIsFormValid] = useState(true);
  const [fieldChecked, setFieldChecked] = useState(false);
  const { requestResetPassword, resetPasswordWithToken } = useActions();
  const { location } = useSelector((state) => state.router);
  const hasToken = !!location["query"]["token"];

  const submitForm = (event) => {
    event.preventDefault();
    if (hasToken) {
      resetPasswordWithToken(password);
    } else {
      requestResetPassword(email);
    }
  };

  useEffect(() => {
    checkFormValidity();
  });

  const checkFormValidity = () => {
    if (hasToken) {
      setIsFormValid(checkFieldValid(USER_PROP.PASSWORD, password));
    } else {
      setIsFormValid(checkEmailValid(email));
    }
  };

  const onClickConfirm = function (e) {
    setPassword(e.target.value);
  };
  const onClickNewPwd = function () {
    setFieldChecked(true);
  };
  const setEmailAdd = function (e) {
    setEmail(e.target.value);
  };
  const onCLickEmail = function () {
    setFieldChecked(true);
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          {hasToken ? "Set New Password" : "Reset Password"}
        </Typography>
        <form className={classes.form} onSubmit={submitForm} noValidate>
          {!hasToken ? (
            <TextField
              variant="outlined"
              margin="normal"
              size="small"
              required
              fullWidth
              label="Email Address"
              name="email"
              autoComplete="email"
              error={fieldChecked && !checkEmailValid(email)}
              onClick={onCLickEmail}
              value={email}
              onChange={setEmailAdd}
              autoFocus
            />
          ) : (
            <PasswordField
              variant="outlined"
              margin="normal"
              size="small"
              required
              fullWidth
              label="New Password"
              name="password"
              autoComplete="password"
              error={
                fieldChecked && !checkFieldValid(USER_PROP.PASSWORD, password)
              }
              onClick={onClickNewPwd}
              type="password"
              value={password}
              onChange={onClickConfirm}
              autoFocus
            />
          )}

          <Button
            type="submit"
            fullWidth
            disabled={!isFormValid}
            variant="contained"
            color="primary"
            className={classes.submit}
          >
            {hasToken ? "Set Password" : "Reset Password"}
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default PasswordChange;
